<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm bg-n-surface-1 rounded-xl overflow-hidden">
    <button
      class="flex items-center select-none w-full bg-transparent m-0 cursor-grab justify-between py-2.5 px-3.5 gap-2 transition-colors hover:bg-n-alpha-1 drag-handle"
      @click.stop="onToggle"
    >
      <div class="flex items-center min-w-0 gap-1.5">
        <EmojiOrIcon
          v-if="icon || emoji"
          class="inline-block w-4"
          :icon="icon"
          :emoji="emoji"
        />
        <h5
          class="text-[10px] tracking-[0.08em] uppercase font-semibold mb-0 py-0 truncate transition-colors"
          :class="isOpen ? 'text-n-brand' : 'text-n-slate-11'"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center flex-shrink-0 gap-1">
        <slot name="button" />
        <span
          class="i-lucide-chevron-down size-3.5 text-n-slate-10 transition-transform duration-200"
          :class="{ 'rotate-180': isOpen }"
        />
      </div>
    </button>
    <div v-if="isOpen" :class="compact ? 'p-0' : 'px-3.5 pb-4 pt-0'">
      <slot />
    </div>
  </div>
</template>
